<template>
  <b-row class="mb-3 mt-3">
    <b-col cols="12">
      <div class="div-separator-prev mb-3 mt-3"></div>
    </b-col>
  </b-row>
</template>
<style lang="scss" scoped>
.div-separator-prev {
  height: 3px;
  width: 100%;
  background-color: #aaaaaa;
}
</style>

<script>
export default {
  name: "Separator",
  props: {
    data: {
      type: Object
    }
  },
  created() {
    console.log(this.data);
  }
};
</script>